import styled from "styled-components/macro";

import type { ThemeProps as Props } from "models/styles/theme";
import { CssClickableIcon, CssIcon } from "styles/helpers/layout";

export const StyledEditButton = styled(CssClickableIcon)<Props>`
  transition: color 0.5s;
  color: ${(props: Props) => props.theme.palette.primary._500};

  :hover {
    color: ${(props: Props) => props.theme.palette.secondary.brand};
  }
`;

export const StyledIcon = styled(CssIcon)<Props>`
  color: ${(props: Props) => props.theme.palette.primary._500};
  background: ${(props: Props) => props.theme.palette.primary._900};
  border-radius: 20px;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 16px;
`;
